import DocTabs from "./DocTabs"

export default function Main() {
    return <main style={{ height: "100%" }}>
        <DocTabs />
    </main>
}
